export function cannotHappen(value: never): never {
  throw new Error(`Unexpected value ${value}`)
}
